import React from "react"
import styles from "./dashboard.module.css"
import { useAuth } from "../../contexts/authContext"
import { NavLink, useParams } from "react-router-dom"
import { BsFunnel } from "react-icons/bs"
import { MdArrowForward, MdOutlineChatBubbleOutline, MdOutlineDashboard } from "react-icons/md"

const Dashboard = () => {
    const { permissions, verifyIfModuleIsActive, showAllOptions } = useAuth()
    const { account_id } = useParams()
    const options = [
        {
            to: `/${account_id}/dashboard-kanban`,
            icon: <BsFunnel />,
            title: "Dashboard do Kanban",
            description: "Acompanhe leads, origens, funis e desempenho comercial."
        },
        ...(verifyIfModuleIsActive("CHAT") && (showAllOptions && permissions?.chat >= 1) ? [{
            to: `/${account_id}/dashboard-chat`,
            icon: <MdOutlineChatBubbleOutline />,
            title: "Dashboard do Chat",
            description: "Analise conversas, atendimento e indicadores dos canais de chat."
        }] : [])
    ]

    return (
        <div className={styles.dashboardHome}>
            <div className={styles.dashboardHeader}>
                <div className={styles.dashboardHeaderIcon}>
                    <MdOutlineDashboard />
                </div>
                <div>
                    <h2>Dashboard</h2>
                    <span>Escolha uma visão para acompanhar os indicadores da conta.</span>
                </div>
            </div>
            <div className={styles.groupOptions}>
                {options.map(option => (
                    <NavLink key={option.to} to={option.to} className={styles.optionLink}>
                        <div className={styles.option}>
                            <div className={styles.optionIcon}>{option.icon}</div>
                            <div className={styles.optionCopy}>
                                <strong>{option.title}</strong>
                                <span>{option.description}</span>
                            </div>
                            <MdArrowForward className={styles.optionArrow} />
                        </div>
                    </NavLink>
                ))}
            </div>
        </div>
    )
}

export default Dashboard
